import React from 'react';
import './index.css';
import clsx from 'classnames';
import { Position } from 'components';
import BuildContent from './components/BuildContent';
import Project from './components/Project';
import { usePageTitle } from '../../hooks';

const Construction = () => {
  // 设置页面标题
  usePageTitle('实验室建设');

  const bannerList = [
    {
      img: '/img/constructionBig.jpg',
      className: 'construction-top-banner-big',
    },
    {
      img: '/img/constructionSmall.jpg',
      className: 'construction-top-banner-small',
    },
  ];

  return (
    <div
      className={clsx('construction-top')}
      style={{ minHeight: window.innerHeight }}
    >
      {/* 顶部Banner */}
      {bannerList.map((item, index) => (
        <img
          key={index}
          src={item.img}
          alt=''
          width={'100%'}
          height={'100%'}
          className={clsx(item.className)}
        />
      ))}
      {/* 当前位置 */}
      <Position list={['首页', '实验室建设']} />
      {/* 实验室建设 */}
      <BuildContent />
      {/* 重点项目 */}
      <Project />
    </div>
  );
};

export default Construction;
